<template>
  <div class="animated fadeIn">
    <fixed-header title="Shipping & Receiving" />
    <!-- <div class="card">
      <div class="card-body margin-top-fixed-header" name="card body">
        <b-tabs>
          <b-tab title="Receive PO's" active v-if="checkClaim(CAN_VIEW_ALL_POS)">
            <purchase-orders-tab />
          </b-tab>
          <b-tab title="Ship SO's" v-if="checkClaim(CAN_VIEW_ALL_SALES_ORDERS)">
            <sales-orders-tab @onRedirect="onRedirect" />
          </b-tab>
          <b-tab title="Ship & Receive WO's" v-if="checkClaim(CAN_VIEW_ALL_WORK_ORDERS)">
            <work-orders-tab @onRedirect="onRedirect" />
          </b-tab>
           <b-tab title="Ship VRMA's" v-if="checkClaim(CAN_VIEW_ALL_VENDOR_RETURNS)">
            <vendor-rma-tab />
          </b-tab>
        </b-tabs>
      </div>
    </div> -->
    <!-- <div class="card"> -->
      <div class="margin-top-fixed-header"> 
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <router-link :to="`/shippingreceiving/pos`" class="nav-link">
              Receive PO's
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="`/shippingreceiving/sos`" class="nav-link">
              Ship SO's
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="`/shippingreceiving/wos`" class="nav-link">
              Ship & Receive WO's
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="`/shippingreceiving/vrmas`" class="nav-link">
              Ship VRMA's
            </router-link>
          </li>
        </ul>
      </div>
   <!--  </div>
     -->

    <div class="tab-content">
      <div class="tab-pane active">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations } from 'vuex';
import FixedHeader from '@/shared/components/FixedHeader/index';
import SalesOrdersTab from './components/SalesOrdersTab'
import PurchaseOrdersTab from './components/PurchaseOrdersTab'
import WorkOrdersTab from './components/WorkOrdersTab';
import VendorRmaTab from './components/VendorRMAsTab';

export default {
  components: {
    FixedHeader,
    SalesOrdersTab,
    PurchaseOrdersTab,
    WorkOrdersTab,
    VendorRmaTab
  },
  metaInfo: () => ({
    title: 'Shipping & Receiving',
  }),
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('shippingReceiving', ['lastOpenedTab'])
  },
  methods: {
    ...mapMutations('shippingReceiving', ['setItem']),
    onRedirect(route) {
      window.open(route.href, '_blank');
    }
  },
  mounted() {
    if (!this.lastOpenedTab) {
      // this.setItem({ resource: 'requirementsLink', payload: this.requirementsLink });
      this.setItem({ resource: 'lastOpenedTab', payload: '/shippingreceiving/pos' });
    }
    if (this.$route.meta.controlLink) {
      this.setItem({ resource: this.$route.meta.controlLink, payload: this.$route.fullPath });
      this.setItem({ resource: 'lastOpenedTab', payload: this.$route.fullPath });
    }
  },  
};
</script>

<style lang="scss">
.tools > * {
  margin: 0 0 0 3px;
}
.b-pagination {
  justify-content: center;
}
table td {
  cursor: pointer;
  white-space: nowrap;
}
</style>
